export enum TrainingOverviewTab {
  Current = 0,
  ToBeClosed = 1,
  Closed = 2,
  Templates = 3
}
